module.exports = __webpack_public_path__ + "static/img/byconcept-02.16e11cc.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/byconcept-02.webp
// module id = 68
// module chunks = 0